<template>
    <div class="property-listing card rounded-3" :class="border ? 'border' : 'border-0'">
        <div class="listing-img-wrapper p-3">
            <div class="list-img-slide position-relative">
                <div class="position-absolute top-0 left-0 ms-3 mt-3 z-1">
                </div>
                <div class="rounded-3 overflow-hidden mb-0 slick-slider">
                    <router-link :to="localizedStandPath(item)">
                        <img :src="`${item.logo}`" class="img-fluid" alt="stand logo" :style="{height: height}" />  
                    </router-link>
                </div>
            </div>
        </div>
        <div class="listing-caption-wrapper px-3">
            <div class="listing-detail-wrapper">
                <div class="listing-short-detail-wrap">
                    <div class="listing-short-detail">
                        <h4 class="listing-name fw-semibold fs-5 mb-2 mt-3"><router-link :to="localizedStandPath(item)">{{item.name}}</router-link></h4>
                        <div v-html="truncatedDescription"></div>
                    </div>
                </div>
            </div>
            <div class="price-features-wrapper d-flex align-items-center justify-content-between my-4">
                <div class="listing-short-detail-flex">
                    <h6 class="listing-card-info-price text-primary ps-0 m-0">{{item.number}}</h6>
                </div>
                <!-- <div class="lst-short-btns-groups d-flex align-items-center">
                    <router-link to="" class="square--50 circle text-primary bg-light-primary me-2"><i class="fa-solid fa-code-compare"></i></router-link>
                    <router-link to="" class="square--50 circle text-success bg-light-success me-2"><i class="fa-solid fa-envelope-open-text"></i></router-link>
                    <router-link to="" class="square--50 circle text-danger bg-light-danger"><i class="fa-solid fa-heart-circle-check"></i></router-link>
                </div> -->
            </div>            
            <!-- <div class="lst-detail-footer d-flex align-items-center justify-content-between border-top py-2 ">
            </div> -->
        </div>
    </div>
</template>

<script setup>
import { defineProps,computed } from 'vue';
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const localizedStandPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return undefined

  return `/${locale.value}/stand/${currentSlug}`
}
const props = defineProps({
  item: Object,
  border: Boolean
});
const truncatedDescription = computed(() => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = props.item.description || '';
  const text = tempDiv.textContent || tempDiv.innerText || '';

  const words = text.split(' ');
  if (words.length > 15) {
    return words.slice(0, 15).join(' ') + '...';
  }
  return text;
});


</script>
